import '../../../../_common/components/toolbar/icon-button.js';
import '../../../../_common/components/toolbar/menu-button.js';
import '../panel/color-panel.js';

import { WithDisposable } from '@blocksuite/block-std';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// import { ColorEvent } from '../panel/color-panel.js';

@customElement('color-picker-button')
export class EdgelessColorPickerButton extends WithDisposable(LitElement) {
  @property()
  accessor label!: string;

  @property()
  accessor tootip: string | undefined = undefined;

  override render() {
    return html`
      <editor-menu-button
        .contentPadding=${'8px'}
        .button=${html`
          <editor-icon-button
            aria-label=${this.label}
            ?tooltip=${this.tootip || this.label}
          >
            <edgeless-color-button></edgeless-color-button>
          </editor-icon-button>
        `}
      >
      </editor-menu-button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'edgeless-color-picker-button': EdgelessColorPickerButton;
  }
}
